import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import isFunction from 'lodash/isFunction';
import classnames from 'classnames';
import MLIcon from '../MLIcon';
import s from './MLCheckBox.module.css';

const checkBoxStatus = (checked, disabled, disabledChecked) => {
  const status = {
    checked: false,
    disabled: false,
  };
  if (checked) status.checked = true;
  if (disabled) status.disabled = true;
  if (disabledChecked) {
    status.checked = true;
    status.disabled = true;
  }
  return status;
};

const getIdentation = (type = '') => {
  if (type === 'activity') {
    return { left: 16 };
  }
  return { left: 0 };
};

function MLCheckBox(props) {
  const {
    checked,
    disabled,
    disabledChecked,
    className,
    inputClassName,
    labelClassName,
    labelText,
    onChange,
    onClick,
    type,
    testId,
    error,
    onKeyDown,
    idLabel,
  } = props;
  const boxId = idLabel || uuidv4();
  const status = checkBoxStatus(checked, disabled, disabledChecked);
  const checkBoxLabelClasses = labelClassName
    ? `${s.MLCheckBoxLabel} ${labelClassName}`
    : s.MLCheckBoxLabel;
  return (
    <div className={`${s.checkboxContainer} ${className}`}>
      <input
        style={getIdentation(type)}
        className={classnames(inputClassName, s.MLCheckBoxInput)}
        checked={status.checked}
        disabled={status.disabled}
        onChange={(e) => isFunction(onChange) && onChange(e, !status.checked)}
        onClick={onClick}
        onKeyDown={onKeyDown}
        id={boxId}
        data-test-id={testId}
        type="checkbox"
        tabIndex={0}
      />
      <label
        className={`${checkBoxLabelClasses} ${
          error && error.length > 0 && s.errorLabel
        }`}
        htmlFor={boxId}
      >
        {labelText && <span>{labelText}</span>}
        {error && error.length > 0 && (
          <MLIcon type="warning" className={s.warningIcon} />
        )}
      </label>
    </div>
  );
}

MLCheckBox.propTypes = {
  type: PropTypes.string,
  error: PropTypes.array,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  disabledChecked: PropTypes.bool,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  labelText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  testId: PropTypes.string,
  idLabel: PropTypes.string,
};

export default MLCheckBox;
